import Contact from '../components/Contact/Contact';
import { Helmet } from "react-helmet";

import Spacer from '../components/Spacer';

function ContactPage(props) {
  return (
    <div>
      <Helmet>
        <title>Business Kontakt | Immovestics</title>
        <meta name="description" content="Wir freuen uns auf Ihre Anfrage und unsere Zusammenarbeit." />
      </Helmet>

      <div className="container">
        <Spacer height="50px" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col s12 l6 offset-l3 insights-container white" style={{"padding":"40px"}}>
            <div className="section">
              <h4>Partner und Business Kontakte</h4>
              <p className="flex-text">Haben Sie Interesse an einer Kooperation? Oder benötigen Sie Zugriff auf unsere Funktionen? Dann freuen wir uns auf Ihre Nachricht!</p>
              <Contact subject="message via partner contact form" />
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <Spacer height="50px" />
      </div>
    </div>
  )
}

export default ContactPage;
